/** Sunum yardımcıları. API şekline dair hiçbir karar burada verilmez. */

export function timeAgo(iso: string | null): string {
  if (!iso) return '—';
  const seconds = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 0) return 'gelecekte';
  if (seconds < 60) return `${seconds} sn önce`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} dk önce`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours} sa önce`;
  return `${Math.round(hours / 24)} gün önce`;
}

export function untilNow(iso: string | null): string {
  if (!iso) return '—';
  const seconds = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
  if (seconds <= 0) return 'doldu';
  if (seconds < 60) return `${seconds} sn`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} dk`;
  return `${Math.round(minutes / 60)} sa`;
}

export function duration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || Number.isNaN(ms)) return '—';
  if (ms < 1000) return `${Math.round(ms)} ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)} sn`;
  return `${Math.round(ms / 60_000)} dk`;
}

export function stamp(iso: string | null): string {
  return iso ? new Date(iso).toLocaleString('tr-TR') : '—';
}

/** Tipsiz metadata torbasından gösterilebilir bir metin okur; tipliymiş gibi davranmaz. */
export function metaText(metadata: Record<string, unknown>, key: string): string | null {
  const value = metadata[key];
  return typeof value === 'string' || typeof value === 'number' ? String(value) : null;
}

/** Bir çalışmanın ürettiği öğe sayısı. Henüz ölçülmediyse tire, sıfır değil. */
export function itemCount(stats: { itemsFound?: number } | undefined): string {
  return typeof stats?.itemsFound === 'number' ? String(stats.itemsFound) : '—';
}

/** Durum kodları operatöre Türkçe gösterilir; API değerleri olduğu gibi kalır. */
const STATUS_TR: Record<string, string> = {
  ACTIVE: 'Aktif',
  DEGRADED: 'Sorunlu',
  COOLDOWN: 'Dinleniyor',
  CHALLENGED: 'Doğrulama bekliyor',
  DISABLED: 'Kapalı',
  DEAD: 'Ölü',
  PENDING: 'Bekliyor',
  QUEUED: 'Sırada',
  RUNNING: 'Çalışıyor',
  SUCCEEDED: 'Başarılı',
  FAILED: 'Başarısız',
  CANCELLED: 'İptal',
  TIMED_OUT: 'Zaman aşımı',
  IDENTITY: 'Kimlik',
  PROXY: 'Proxy',
};

export function statusLabel(status: string): string {
  return STATUS_TR[status] ?? status;
}

const EVENT_TR: Record<string, string> = {
  CREATED: 'Oluşturuldu',
  UPDATED: 'Güncellendi',
  DELETED: 'Silindi',
  ENABLED: 'Açıldı',
  DISABLED: 'Kapatıldı',
  HEALTH_CHECK: 'Sağlık kontrolü',
  LEASE_ACQUIRED: 'Kiralandı',
  LEASE_RELEASED: 'Bırakıldı',
  PROXY_ASSIGNED: 'Proxy bağlandı',
  PROXY_UNASSIGNED: 'Proxy kaldırıldı',
  COOLDOWN_STARTED: 'Dinlenmeye alındı',
  CHALLENGE_DETECTED: 'Doğrulama istendi',
};

export function eventLabel(type: string): string {
  return EVENT_TR[type] ?? type;
}

/**
 * Mikro-USD'yi okunur bir tutara çevirir.
 *
 * Küçük tutarlar da görünmeli: aylık harcama birkaç dolar olduğunda "$0.00" yazan bir
 * panel, harcamanın olmadığını değil ölçeğin yanlış olduğunu söyler. Bir sentin altında
 * kalan tutarlar bu yüzden dört haneye kadar açılıyor.
 */
export function money(microUsd: number | null | undefined): string {
  if (microUsd === null || microUsd === undefined) return '—';
  const usd = microUsd / 1_000_000;
  if (usd === 0) return '$0';
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  if (usd < 1) return `$${usd.toFixed(3)}`;
  return `$${usd.toFixed(2)}`;
}

/** Büyük sayıları okunur kısaltır: 1.032.480 yerine 1,03 M. */
export function compactNumber(value: number): string {
  if (value < 1_000) return String(value);
  if (value < 1_000_000) return `${(value / 1_000).toFixed(1).replace('.', ',')} B`;
  return `${(value / 1_000_000).toFixed(2).replace('.', ',')} M`;
}
